/* Amtacor PDP - Convert <h2> sections inside product description into collapsible accordions.
   Desktop (>=990px): all open by default
   Mobile (<990px):   all closed by default
   Idempotent: safe to call multiple times. */
(function () {
  function enhance(container) {
    if (!container || container.dataset.pdpAccordionEnhanced === '1') return;
    container.dataset.pdpAccordionEnhanced = '1';

    var children = Array.prototype.slice.call(container.children);
    var groups = [];
    var intro = [];
    var current = null;

    children.forEach(function (el) {
      if (el.tagName === 'H2') {
        current = { heading: el, content: [] };
        groups.push(current);
      } else if (current) {
        current.content.push(el);
      } else {
        intro.push(el);
      }
    });

    if (groups.length === 0) return;

    // Clear container and rebuild
    container.innerHTML = '';

    // Intro paragraph(s) stay on top, not collapsed
    intro.forEach(function (el) {
      el.classList.add('pdp-intro');
      container.appendChild(el);
    });

    groups.forEach(function (g) {
      var details = document.createElement('details');
      details.className = 'pdp-accordion';
      // Always collapsed by default (both desktop and mobile)

      var summary = document.createElement('summary');
      summary.textContent = g.heading.textContent;
      details.appendChild(summary);

      var content = document.createElement('div');
      content.className = 'pdp-accordion__content';
      g.content.forEach(function (el) { content.appendChild(el); });
      details.appendChild(content);

      container.appendChild(details);
    });
  }

  function init() {
    // Trade/Dawn themes - product description wrapper
    var selectors = [
      '.product__description',
      '[data-product-description]',
      '.product-single__description'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var nodes = document.querySelectorAll(selectors[i]);
      for (var j = 0; j < nodes.length; j++) enhance(nodes[j]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-run on Shopify section reload (theme editor)
  document.addEventListener('shopify:section:load', init);
})();
